<template>
  <input
      :type="type"
      :placeholder="placeholder"
      :value="value"
      :disabled="disabled"
      class="form-control"
      @input="input"
      @keyup.enter="enter"
      @blur="blur"
      :class="state !== null ? (state ? 'd-input-success' : 'd-input-error') : 'd-input-info'"
  />
</template>

<script>

export default {
  name: "DTextInput",
  props: {
    type: String,
    value: [String, Number],
    placeholder: String,
    inputGroup: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    state: {
      default: null
    }
  },
  methods: {
    input(event) {
      this.$emit("input", event.target.value);
    },
    enter(event) {
      this.$emit("enter", event.target.value);
    },
    blur(event) {
      this.$emit("blur", event.target.value);
    }
  }
};
</script>
